<template>
  <sl-page>
    <div class='page-filter'>
      <Row :gutter="12">
        <Col span="8" :lg="8" :md="8" :sm="12" :xs="24" class="margin-bottom">
        <Input v-model="params.carNo" placeholder="请车辆编号"></Input>
        </Col>
        <Col span="8" :lg="8" :md="8" :sm="12" :xs="24" class="margin-bottom">
        <Input v-model="params.imei" placeholder="请输入IMEI"></Input>
        </Col>
        <Col span="8" :lg="8" :md="8" :sm="24" :xs="24" class="page-action">
        <div>
          <Button type="primary" icon="ios-search" @click="list()">搜索</Button>
          <Button icon="ios-reset" @click="reset()">清空</Button>
        </div>
        <div>
          <Button type="primary" icon="md-download" @click="exports()">导出</Button>
        </div>
        </Col>
      </Row>
    </div>
    <div class="pg-bd">
      <sl-table ref="table" :loading="loading" :page="page" :columns="columns" :data="data" @on-selection-change="handleSelect" @on-update="handleChange"></sl-table>
    </div>
  </sl-page>
</template>
<script>
import global from '@/util/mixin/global'

const longitudeDisplay = (d) => `${d.longitude}°${d.longitude > 0 ? 'E' : 'W'}`
const latitudeDisplay = (d) => `${d.latitude}°${d.latitude > 0 ? 'N' : 'S'}`

export default {
  components: {},
  mixins:[global],
  
  data() {
    return {
      columns: [{
          type: 'index',
          width: 65,
          title: '序号',
          align: 'center'
        },
        {
          title: '车辆编号',
          key: 'carNo',
          minWidth: 100,
        },
        {
          title: 'IMEI',
          key: 'imei',
          minWidth: 150,
        },
        {
          title: '时间',
          key: 'recordDatetimeText',
          minWidth: 160,
        },
        {
          title: '纬度',
          key: 'latitudeDisplay',
          minWidth: 150,
        },
        {
          title: '经度',
          key: 'longitudeDisplay',
          minWidth: 150,
        },
        {
          title: '速度',
          key: 'speed',
          minWidth: 120,
        },
        {
          title: '方位',
          key: 'degrees',
          minWidth: 100,
        },
        {
          title: '里程',
          key: 'mileage',
          minWidth: 90,
        }
      ],

      params: {
        carNo: null,
        imei: null,
      },
      page: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      data: [],
      loading: false,
    }
  },
  computed: {

  },
  created() {
    this.def = { ...this.params }

    this.list()
  },

  methods: {

    list() {
      let params = { search: { ...this.params }, pageSize: this.page.pageSize, pageNum: this.page.pageNum }
      this.$request.devicesLocation(params).then(resp => {
        if (resp.code == 0) {
          this.data = this.$utils.flat(this.$utils.conv(resp.data.list || [], { 'recordDatetime': 'datetime', latitudeDisplay, longitudeDisplay }))
          this.page.total = resp.data.total || 0
        } else {
          this.$Message.error({ content: resp.msg })
        }
      })
    },

    exports() {
      this.$request.devicesLocationExport().then(resp => {
        console.log(resp)
      })
    },

    reset() {
      this.$utils.fill(this.params, this.def)
      this.list()
    },

    handleUpdate() {
      this.modalVisible = false
      this.list()
    },

    handleChange(pageNum, pageSize) {
      if (this.page.pageNum != pageNum || this.page.pageSize != pageSize) {
        this.page.pageNum = pageNum
        this.page.pageSize = pageSize
        this.list()
      }
    },

    handleSelect(selection) {
      this.selection = selection.map(i => i.id)
    }
  }
}

</script>
